<div class="content-loader" [class]="!loaderService.loader ? 'end' : ''" [ngStyle]="{'height': height}">
    <mat-spinner *ngIf="loaderService.loader; else content" [diameter]="diameter"></mat-spinner>
    <ng-template #content>
        <ng-content></ng-content>
    </ng-template>
</div>